import { Component, Input } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';

@Component({
  selector: 'app-subscription-buyer-plan',
  templateUrl: './subscription-buyer-plan.component.html',
  styleUrls: ['./subscription-buyer-plan.component.css']
})
export class SubscriptionBuyerPlanComponent {
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;
  @Input() is_modal: any;

  planFeatures = {
    standard: {
      original_price: 475,
      price: 47.5,
      planName: "Standard Plan",
      features: [
        { label: "Plan validity", value: "30 Days"},
        { "label": "Number of units/property", "value": "Up to 25" },
        { "label": "Mortgage advisory assistance", "value": "" },
        { "label": "Relationship manager assistance", "value": "" },
        { "label": "", "value": "" },
        { "label": "", "value": "" },
        { "label": "", "value": "" },
        { "label": "", "value": "" },
      ]
    },
    premium: {
      original_price: 875,
      price: 87.5,
      planName: "Premium Plan",
      features: [
        { label: "Plan validity", value: "60 Days"},
        { "label": "Number of units/property", "value": "Unlimited" },
        { "label": "Mortgage advisory assistance", "value": "" },
        { "label": "Dedicated relationship manager", "value": "" },
        { "label": "End of end viewing coordination", "value": "" },
        { "label": "Property registration and transfer assistance", "value": "" },
        { "label": "Choice to maintain privacy of the contact details", "value": "" },
        { "label": "Instant property alerts on SMS/WhatsApp", "value": "" }
      ]
    }
  }

  constructor(public shared: SharedService, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }

  async onSubmit(type: any) {
    let amount: any;
    if (type == 1) {
      amount = 175
    } else {
      amount = 350
    }
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_SUBSCRIPTION_PLAN, {
      subscription_type: 2,
      subscription_sub_type: type,
      subscription_date: new Date(),
      subscription_amount: amount
    })
    if (res && !res.error) {
      window.location.href = '/';
    }
  }
}
